import { loadersCommonProps } from '../../config';

const props = {
  ...loadersCommonProps,

  /**
   * The loader state.
   */
  isActive: {
    type: Boolean,
    default: false
  },

  /**
   * The loading message.
   */
  loadingMessage: {
    type: [String, Boolean],
    default: 'Carregando. Aguarde...',
    validator: (value) => !!(typeof value === 'string' || value === false)
  }
}

export const muiLoaderFullPage = {
  props
}

